import "../../../../../../src/css/FinancialPromotions/Components/Buttons/Checkbox.css";

const Checkbox = ({
  id,
  name,
  label,
  checked,
  onChange,
  disabled = false,
  error = false,
  helperText,
}) => {
  const inputId =
    id || `checkbox-${label?.replace(/\s+/g, "-")?.toLowerCase()}`;

  return (
    <div className={`ds-checkbox ${error ? "ds-checkbox--error" : ""}`}>
      <label htmlFor={inputId} className="ds-checkbox-label">
        <input
          id={inputId}
          name={name || id}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span className="FP_Content">{label}</span>
      </label>
      {/* {helperText && (
        <div
          className={`ds-input-helper ${error ? "ds-input-helper--error" : ""}`}
        >
          {helperText}
        </div>
      )} */}
    </div>
  );
};

export default Checkbox;
